import {
    SETTINGS_FIELD_UPDATED,
    LANGUAGE_SWITCH, LANGUAGE_SWITCH_SUCCESSFUL, LANGUAGE_SWITCH_FAILED
} from "../actions/Types";

const INITIAL_STATE = {
    language: false
};

const SettingReducer =  (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case SETTINGS_FIELD_UPDATED:
            return { ...state, [action.payload.prop]: action.payload.value };

        case LANGUAGE_SWITCH:
            return { ...state };
        case LANGUAGE_SWITCH_SUCCESSFUL:
            return { ...state };
        case LANGUAGE_SWITCH_FAILED:
            return { ...state };

        default:
            return state;
    }
};

export default SettingReducer;